import { render, staticRenderFns } from "./AssessmentResult.vue?vue&type=template&id=6901cc6c&"
import script from "./AssessmentResult.vue?vue&type=script&lang=js&"
export * from "./AssessmentResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports